import { useEffect } from 'react';
import { formatCount } from '@gonfalon/format/formatCount';
import { formatNumber } from '@gonfalon/format/formatNumber';
import { pluralize } from '@gonfalon/format/pluralize';
import { pluralizeWord } from '@gonfalon/format/pluralizeWord';
import { announce } from '@react-aria/live-announcer';
import classNames from 'clsx';

import './styles.css';
export type CounterHeaderProps = {
  resource: string;
  resourceCount: number;
  className?: string;
  shortForm?: boolean;
  truncate?: boolean;
};

export function CounterHeader({ resource, resourceCount, className, shortForm, truncate }: CounterHeaderProps) {
  useEffect(() => {
    if (resourceCount > 0) {
      announce(
        `${formatNumber(resourceCount)} ${pluralize(resourceCount, resource, pluralizeWord(resource))}`,
        'polite',
        300,
      );
    }
  }, [resource, resourceCount]);
  return (
    <div className={classNames('CounterHeader', className)}>
      <div className={truncate ? 'CounterHeader-ellipse ' : 'u-pullright'}>
        {resourceCount > 0 && (
          <>
            <strong>{shortForm ? formatCount(resourceCount, false) : formatNumber(resourceCount)}</strong>{' '}
            {pluralize(resourceCount, resource, pluralizeWord(resource))}
          </>
        )}
      </div>
    </div>
  );
}
